var _circle, _path, _circle2, _circle3, _g, _path2, _circle4, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvatar2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#B6EDFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 108C83.8234 108 108 83.8234 108 54C108 24.1766 83.8234 0 54 0V108Z",
    fill: "#00B0EF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 43,
    fill: "#B6EDFD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_586_782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#00B0EF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_586_782)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 15.0378,
    y: 61.519,
    width: 43.7468,
    height: 50.5823,
    rx: 6,
    fill: "#00B0EF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 83C45.0604 83 52 76.2843 52 68H21C21 76.2843 27.9396 83 36.5 83Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_586_782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 54,
    cy: 54,
    r: 54,
    fill: "#00B0EF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_586_782)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16.6154,
    cy: -23.5384,
    r: 59.5385,
    fill: "#00B0EF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar2);
export default __webpack_public_path__ + "static/media/avatar2.c43e685710c9cf18cdaed5ab9e8dc5a8.svg";
export { ForwardRef as ReactComponent };